/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlanSetup/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlanSetup({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/PaymentPlanSetup"
  
}) {
let paymentPlanDiscounts0ValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts.[0]',
format: fromHelpers.getConfiguredDiscount,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.discounts.[0]"
 format="helpers.js getConfiguredDiscount"
 text={paymentPlanDiscounts0ValueData}
 weight="medium"
 color={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}